<template>
    <el-input
        :value="label"
        :class="{'is-focus': levelSelect.popoverVisible && !levelSelect.innerDisabled, 'is-disabled': levelSelect.innerDisabled}"
        :size="levelSelect.selectSize"
        :validate-event="false"
        :placeholder="levelSelect.placeholder"
        :readonly="true"
        :clearable="levelSelect.clearable"
        @focus="handleFocus"
        @click.native="handleClick"
    >
        <i slot="suffix" class="icon" :class="icon" @click="handleClear"></i>
    </el-input>
</template>
<script>
export default {
    props: {
        icon: {type: String}
    },
    inject: ['levelSelect'],
    data() {
        return {
            showClose: false
        };
    },
    computed: {
        label() {
            const value = this.levelSelect.store.selectedValue;
            if (!value || !value.length) {
                return '';
            }
            if (value.length === 1) {
                return value[0].label;
            }
            return `已选择${value.length}个`;
        },
    },
    methods: {
        handleFocus() {
            const { store, innerDisabled } = this.levelSelect;
            if (innerDisabled && store.selectedValue.length <= 1) {
                // 如果disabled并且选中数量小于1
                return;
            }
            this.levelSelect.popoverVisible = true;
            this.levelSelect.shouldTrigger = true;
        },
        handleClick() {
            const { store, innerDisabled } = this.levelSelect;
            if (!innerDisabled || store.selectedValue.length <= 1) {
                return;
            }
            this.levelSelect.popoverVisible = true;
            this.levelSelect.shouldTrigger = true;
        },
        handleClear() {
            this.$emit('clear');
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../../styles/common/var.scss';

.is-focus {
    /deep/ .el-input__inner {
        border-color: $--color-primary;
    }
}
.icon {
    width: 25px;
}
/deep/ {
    .el-input__suffix {
        display: flex;
        align-items: center;
    }
}
.el-icon-circle-close {
    cursor: pointer;
}
</style>
